var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseBig(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M7.983 6.455l4.34-4.34a1.105 1.105 0 011.562 1.562l-4.34 4.34 4.34 4.34a1.08 1.08 0 11-1.528 1.528l-4.34-4.34-4.34 4.34a1.105 1.105 0 01-1.562-1.562l4.34-4.34-4.34-4.34a1.08 1.08 0 111.528-1.528l4.34 4.34z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNiIgaGVpZ2h0PSIxNiIgdmlld0JveD0iMCAwIDE2IDE2Ij4KICA8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03Ljk4MyA2LjQ1NWw0LjM0LTQuMzRhMS4xMDUgMS4xMDUgMCAwMTEuNTYyIDEuNTYybC00LjM0IDQuMzQgNC4zNCA0LjM0YTEuMDggMS4wOCAwIDExLTEuNTI4IDEuNTI4bC00LjM0LTQuMzQtNC4zNCA0LjM0YTEuMTA1IDEuMTA1IDAgMDEtMS41NjItMS41NjJsNC4zNC00LjM0LTQuMzQtNC4zNGExLjA4IDEuMDggMCAxMTEuNTI4LTEuNTI4bDQuMzQgNC4zNHoiLz4KPC9zdmc+Cg==";
export { SvgCloseBig as ReactComponent };